// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Sl7lx","text":"styles_text__1jKqg","icon":"styles_icon__1LZQp","button":"styles_button__1WLzo"};